import React from 'react';

function PaginationRight2Icon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.14645 4.64645C4.34171 4.45118 4.65829 4.45118 4.85355 4.64645L9.85355 9.64645C10.0488 9.84171 10.0488 10.1583 9.85355 10.3536L4.85355 15.3536C4.65829 15.5488 4.34171 15.5488 4.14645 15.3536C3.95118 15.1583 3.95118 14.8417 4.14645 14.6464L8.79289 10L4.14645 5.35355C3.95118 5.15829 3.95118 4.84171 4.14645 4.64645ZM10.1464 4.64645C10.3417 4.45118 10.6583 4.45118 10.8536 4.64645L15.8536 9.64645C16.0488 9.84171 16.0488 10.1583 15.8536 10.3536L10.8536 15.3536C10.6583 15.5488 10.3417 15.5488 10.1464 15.3536C9.95118 15.1583 9.95118 14.8417 10.1464 14.6464L14.7929 10L10.1464 5.35355C9.95118 5.15829 9.95118 4.84171 10.1464 4.64645Z"
        fill="#121212"
      />
    </svg>
  );
}

export default PaginationRight2Icon;
